import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AcademicFeePriceDto } from '../models/academicfeepricedto';
import { PaginationFeaturesDto } from '../models/paginationfeaturesdto';
import { AppConfigService } from './core/appConfig.service';

@Injectable({
    providedIn: 'root'
})

export class LearningResourceFeePriceService {

    constructor(private http: HttpClient, private configService:AppConfigService) { }

    getByLearningResourceId(pageRequest: PaginationFeaturesDto, idOwnLearningResource: number): Observable<any> {
        const params = new HttpParams()
            .set('page', pageRequest.page)
            .set('sizePage', pageRequest.sizePage)
            .set('orderField', pageRequest.orderField)
            .set('order', pageRequest.order);
        return this.http.get<any>(`${this.configService.apiUrl}/configuration/own-learning-resource/price-detail/getAll?${params}&idOwnLearningResourceRate=${idOwnLearningResource}`).pipe(
            map(response => { return response; }));
    }

    insertLearningResourceFeePrice(learningResourceFeePrice: AcademicFeePriceDto): Observable<any> {
        return this.http.post<any>(`${this.configService.apiUrl}/configuration/own-learning-resource/price-detail/insert`, learningResourceFeePrice).pipe(
            map(response => { return response; }));
    }

    updateLearningResourceFeePrice(learningResourceFeePrice: AcademicFeePriceDto): Observable<any> {
        return this.http.put<any>(`${this.configService.apiUrl}/configuration/own-learning-resource/price-detail/update`, learningResourceFeePrice).pipe(
            map(response => {
                return response;
            })
        );
    }
}